import { DownOutlined, EditOutlined, SwapOutlined, UpOutlined } from '@ant-design/icons'
import { useUserStore } from '@store/user'
import type { MenuProps } from 'antd'
import { Dropdown, message, Space } from 'antd'
import { useTranslation } from 'react-i18next'

import { useDictionary } from '@/hooks/useDictionary'
import { useHeaderStore } from '@/store/header'
import { PERSONAL_CENTER_SECTION_KEYS } from '@/views/Personalcenter/constants/sections'

import { resolveCustomerAccountMenuBehavior } from '../customer-picker'
import CustomerSwitcher from '../CustomerSwitcher'
import AccountStyle from './index.module.scss'

const NAVIGATE_MENU_KEY_PREFIX = 'navigate:'

function Account() {
  const changeIndex = useHeaderStore((state) => state.changeIndex)

  // 个人中心切换变量
  const { setIsInformation } = usePersonalcenterStore((state) => state)

  // 密码登录的变量全局控制加载变量--把布尔值注入进去和控制加载标题的变量
  const { setIsLoginPwdreg } = useLoginStore((state) => state)

  const { t } = useTranslation()
  const navigate = useNavigate()
  const listArr = [
    { icon: 'dingdan', label: 'myorder', path: '/order' },
    { icon: 'shouhou', label: 'aftersales', path: '/order/afterSales' },
    { icon: 'qianbao', label: 'mywallet', path: '/wallet' },
    { icon: 'qianbao', label: 'mymember', path: '/ai/member' },
    { icon: 'zhanghao', label: 'mydrive', path: '/drive' },
    { icon: 'zhanghao', label: 'personal', path: '/personalcenter' },
    { icon: 'shoucang', label: 'myfavorite', path: '/home/favorite' },
  ]

  // setToken
  const { resetUser, token, userInfo } = useUserStore((state) => state)
  useDictionary(token ? true : false)

  const logOut = async () => {
    resetUser()
    navigate('/login')
    setIsLoginPwdreg(0)
    message.success('退出成功')
  }

  const navigateTo = (path: string) => {
    changeIndex(-1)
    navigate(path, { replace: true })

    // 新增代码
    if (path == '/personalcenter') {
      // 切回当前个人信息页
      setIsInformation(PERSONAL_CENTER_SECTION_KEYS.PROFILE)
    }
  }

  const listStyle = {
    display: 'flex',
    cursor: 'pointer',
    fontWeight: 400,
    fontSize: '16px',
    padding: '0 5px',
    lineHeight: '40px',
    // margin: '0 20px',
  }
  const navigationItems: MenuProps['items'] = listArr.map((item) => {
    return {
      key: `${NAVIGATE_MENU_KEY_PREFIX}${item.path}`,
      style: { padding: '3px 12px' },
      label: (
        <div className={AccountStyle.listitem} style={listStyle}>
          <i className={'iconfont icon-' + item.icon} style={{ color: '#999999', fontSize: '18px' }}></i>
          <div style={{ marginLeft: '6px', color: '#222222' }}>{t('header.account.' + item.label)}</div>
        </div>
      ),
    }
  })

  const [isOpen, setIsOpen] = useState(false)
  const onStatusChange = (open: boolean) => {
    setIsOpen(open)
  }

  const handleLogin = () => {
    navigate('/login')
    // 然后显示密码登录才对,而不是显示验证码登录
    setIsLoginPwdreg(0)
    // setToken("8756670000000")

    // const from = location?.state?.from?.pathname || "/" // 如果没有来源路径则重定向到首页
    // navigate(from, { replace: true })
  }
  if (token) {
    return (
      <CustomerSwitcher>
        {({ currentCustomer, customerCount, loading, openCustomerEditor, openCustomerPicker }) => {
          const behavior = resolveCustomerAccountMenuBehavior(customerCount, currentCustomer != null)
          const currentAccountName =
            loading && !currentCustomer
              ? t('header.account.accountLoading')
              : currentCustomer?.name || t('header.account.accountUnselected')
          const customerItems: MenuProps['items'] = [
            {
              key: 'current-account',
              disabled: true,
              className: AccountStyle.currentAccountItem,
              label: (
                <div className={AccountStyle.currentAccount} title={currentCustomer?.name || undefined}>
                  <span>{t('header.account.currentAccount')}</span>
                  <strong>{currentAccountName}</strong>
                  {currentCustomer?.companyName ? <small>{currentCustomer.companyName}</small> : null}
                </div>
              ),
            },
            ...(behavior.showSwitchAccount
              ? [
                  {
                    key: 'switch-account',
                    icon: <SwapOutlined />,
                    label: t('header.account.switchAccount'),
                  },
                ]
              : []),
            {
              key: 'edit-customer',
              icon: <EditOutlined />,
              label: t('header.account.editCustomer'),
              disabled: !behavior.canEditCustomer,
            },
            { type: 'divider' },
          ]
          const itemsList: MenuProps['items'] = [
            ...customerItems,
            ...navigationItems,
            { type: 'divider' },
            {
              key: 'logout',
              style: { padding: '3px 12px' },
              label: (
                <div className={AccountStyle.listitem} style={listStyle}>
                  <i className="iconfont icon-tuichu" style={{ color: '#999999', fontSize: '18px' }}></i>
                  <div style={{ marginLeft: '6px', color: '#222222' }}>{t('header.account.logout')}</div>
                </div>
              ),
            },
          ]

          const onMenuClick: MenuProps['onClick'] = ({ key }) => {
            if (key === 'switch-account') {
              openCustomerPicker()
              return
            }
            if (key === 'edit-customer') {
              openCustomerEditor()
              return
            }
            if (key === 'logout') {
              void logOut()
              return
            }
            if (key.startsWith(NAVIGATE_MENU_KEY_PREFIX)) navigateTo(key.slice(NAVIGATE_MENU_KEY_PREFIX.length))
          }

          return (
            <Dropdown
              menu={{ items: itemsList, onClick: onMenuClick }}
              placement="bottomRight"
              arrow
              overlayClassName={AccountStyle.accountMenu}
              onOpenChange={onStatusChange}
            >
              <a onClick={(e) => e.preventDefault()} className=" w-[122px]  cursor-pointer " style={{ color: '#000' }}>
                <Space>
                  <div className="max-w-[85px] truncate overflow-hidden text-ellipsis whitespace-nowrap">
                    {userInfo?.username}
                  </div>
                  {isOpen ? <DownOutlined /> : <UpOutlined />}
                </Space>
              </a>
            </Dropdown>
          )
        }}
      </CustomerSwitcher>
    )
  } else {
    return (
      <div className={AccountStyle.tologin} onClick={handleLogin}>
        {t('login.btn')}
      </div>
    )
  }
}

export default Account
